module.exports = __webpack_public_path__ + "img/changjing-01.dcc1cbeb.png";